export enum LeadActionType {
  GET_LAED_SUMMARY_BY_UUID_FAILURE = '@@lead/GET_LEAD_SUMMARY_BY_UUID_FAILURE',
  GET_LAED_SUMMARY_BY_UUID_REQUEST = '@@lead/GET_LEAD_SUMMARY_BY_UUID_REQUEST',
  GET_LAED_SUMMARY_BY_UUID_SUCCESS = '@@lead/GET_LEAD_SUMMARY_BY_UUID_SUCCESS',

  GET_LEADS_FAILURE = '@@lead/GET_LEADS_FAILURE',
  GET_LEADS_REQUEST = '@@lead/GET_LEADS_REQUEST',
  GET_LEADS_SUCCESS = '@@lead/GET_LEADS_SUCCESS',

  GET_LEAD_BY_UUID_FAILURE = '@@lead/GET_LEAD_BY_UUID_FAILURE',
  GET_LEAD_BY_UUID_REQUEST = '@@lead/GET_LEAD_BY_UUID_REQUEST',
  GET_LEAD_BY_UUID_SUCCESS = '@@lead/GET_LEAD_BY_UUID_SUCCESS',

  GET_LEAD_SUMMARIES_FAILURE = '@@lead/GET_LEAD_SUMMARIES_FAILURE',
  GET_LEAD_SUMMARIES_REQUEST = '@@lead/GET_LEAD_SUMMARIES_REQUEST',
  GET_LEAD_SUMMARIES_SUCCESS = '@@lead/GET_LEAD_SUMMARIES_SUCCESS',

  LEADS_UTIL_STATE_CHANGE = '@@lead/LEADS_UTIL_STATE_CHANGE',
  LEAD_SUMMARIES_UTIL_STATE_CHANGE = '@@lead/LEAD_SUMMARIES_UTIL_STATE_CHANGE',
}
